<template>
    <div class="table_checkbox_container">
        <div class="table_checkbox">
            <input :id="checkboxId" class="table_check_input" type="checkbox" v-model="checked" @change="$emit('change', val)" >
            <label :for="checkboxId"></label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TableSelectCheckbox',
    props: ['checkboxId'],
    props: {
        isChecked: {
            type: Boolean,
            required: true
        },
        checkboxId: {
            type: String,
            required: true
        }
    },
    mounted(){
        this.val = this.isChecked
    },
    components: {},
    data(){
        return {
            val: false
        }
    },
    computed: {
	    checked: {
            get () {
                return this.isChecked
            },
            set (val) {
                this.val = val
            }
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.table_checkbox_container{
    display: flex;
    align-items: center;
    min-height: 42px;
    user-select: none;
    .table_checkbox{
        display: flex;
        align-items: center;
        justify-content: center;
        label{
            width: 16px;
            height: 16px;
            border: 2px solid $grey-light;
            display: block;
            border-radius: 4px;
            cursor: pointer;
            transition: .15s all;
        }
        .table_check_input{
            width: 0;
            height: 0;
            display: block;
        }
        .table_check_input:checked + label{
            position: relative;
            border-color: $info;
            &:after{
                content: "";
                position: absolute;
                width: 10px;
                height: 3px;
                background-color: $info;
                display: block;
                top: 4px;
                left: 1px;
                border-radius: 100%;
            }
        }
    }
}
</style>